(function() {
    'use strict';

    // --- Scroll reveal ---
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function(el) {
        observer.observe(el);
    });

    // --- Sticky cart on mobile ---
    var productSection = document.getElementById('product');
    var stickyCart = document.getElementById('stickyCart');

    if (productSection && stickyCart && window.innerWidth <= 768) {
        var productObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // Only show once the user has scrolled PAST the product section —
                // never on landing, when the product is still below the fold.
                var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                stickyCart.classList.toggle('show', scrolledPast);
                document.body.classList.toggle('sticky-bar-on', scrolledPast);
            });
        }, { threshold: 0 });
        productObserver.observe(productSection);
    }

    // --- WhatsApp float: hidden on landing (it covered the hero CTA), shows after scroll ---
    var waFloat = document.querySelector('.wa-float');
    if (waFloat) {
        var waCheck = function() {
            if (window.scrollY > 350) {
                waFloat.classList.add('wa-show');
                window.removeEventListener('scroll', waCheck);
            }
        };
        window.addEventListener('scroll', waCheck, { passive: true });
        waCheck();
    }
})();
